import styled from 'styled-components';
import {Select, Space} from 'antd';
import Search from '../../../../../Search';

const StyledTableFilters = styled(Space)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  overflow-x: auto;

  .ant-btn {

    .ant-wave {
      display: none !important;
    }

    &.ant-btn-primary {
      .ant-btn-icon {
        svg {
          height: 16px;
          width: 16px;
          path {
            stroke: ${props => props.theme.colors.primary_1};
          }
        }
      }
    }
  }
`;

const StyledTableFiltersSelect = styled(Select)`
  min-width: 190px;

  &.ant-select-lg {
    .ant-select-selector {
      &::after {
        line-height: 30px;
      }
    }
  }
`;

const StyledTableFiltersSearch = styled(Search)`
  width: 168px;
`;

export {
  StyledTableFilters,
  StyledTableFiltersSearch,
  StyledTableFiltersSelect
};
